import { PortfolioOverview } from "@pages/portfolio/overview/overview";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/portfolio/overview")({
	component: PortfolioOverview,
});
